import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Home from './HomePage';
import ServicesStatic from '../components/ServicesStatic';
import Testimonials from '../components/Testimonials';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen visitor-page">
      <Navbar />
      <Hero />
      <Home />
      <ServicesStatic />
      <Testimonials />
      <Gallery />
      {/* <CTASection /> */}
      <Footer />
    </div>
  );
};

export default LandingPage;
